import { useCallback, useRef } from 'react';

/**
 * Returns a stable idempotency token per selection key, so retries of the
 * same selection (e.g. same Stripe price) resend the same token while a
 * different selection gets a fresh one.
 */
export function useIdempotencyToken() {
  const tokensRef = useRef<Map<string, string>>(new Map());

  return useCallback((selectionKey: string): string => {
    const existing = tokensRef.current.get(selectionKey);
    if (existing) {
      return existing;
    }
    const token = crypto.randomUUID();
    tokensRef.current.set(selectionKey, token);
    return token;
  }, []);
}
